export enum CourseRecomActionTypes {
    FETCH_REQUEST = '@@CourseRecom/FETCH_REQUEST',
    FETCH_SUCCESS = '@@CourseRecom/FETCH_SUCCESS',
    FETCH_ERROR = '@@CourseRecom/FETCH_ERROR',

    SELECT = '@@CourseRecom/SELECT',
    SELECTED = '@@CourseRecom/SELECTED',
    CLEAR_SELECTED = '@@CourseRecom/CLEAR_SELECTED',
    ADD_SUCCESS = '@@CourseRecom/ADD_SUCCESS',

    EDIT = '@@CourseRecom/EDIT',
    UPDATE_EDIT = '@@CourseRecom/UPDATE_EDIT',
    EDIT_SUCCESS = '@@CourseRecom/EDIT_SUCCESS'
}

export interface CourseRecomUIState {
    readonly loading: boolean
    readonly selected?: number
    readonly errors?: string
    readonly totDoc?: number

}